import React from 'react';
import {GlobalContext} from "../../GlobalContext";
import {Glyph} from "../common/Glyph";
import {Col, FormControl, Row} from "react-bootstrap";
import {cols, operators, types} from "./MarketingQueryView";
import CollapsibleMultiSelect from "../common/CollapsibleMultiSelect";

export default class MarketingQueryFilterRow extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            lookupValues: []
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let f = this.props.filter;
        let prevFilter = prevProps.filter;
        let col = f.col;
        let prevCol = prevFilter.col;
        let t = col.type;

        if (t === types.lookup) {
            if (prevCol !== col || this.state.lookupValues.length === 0) {
                this.fetchLookupValues(col);
            }
        }
    }

    fetchLookupValues = (col, cb) => {
        if (!col) col = this.props.filter.col;
        let uri = `/lookup/${col.lookupTable}${col.filter ? `?filter=${col.filter}` : ""}`;
        this.context.cachedGet(uri, 300)
            .then(resp => {
                if (resp && resp.data) {
                    this.setState({lookupValues: resp.data}, cb);
                }
            });
    }

    changeCol = (key) => {
        let newFilter = {...this.props.filter};
        newFilter.col = this.props.cols.find(c => c.key === key);
        newFilter.operator = newFilter.col.type.operators[0];
        let col = newFilter.col;
        let type = col.type;
        if (type === types.enum) {
            // Select first value by default
            newFilter.value = col.values[0];
        } else if (type === types.lookup) {
            this.fetchLookupValues(col, () => {
                // select first value by default
                newFilter.value = this.state.lookupValues[0][col.valueKey];
                this.props.onChange(newFilter)});
        } else {
            newFilter.value = "";
        }
        // Fire the onChange handler, but only if it wasn't a lookup type
        if (type !== types.lookup) this.props.onChange(newFilter);
    }

    changeOperator = (key) => {
        let newFilter = {...this.props.filter};
        newFilter.operator = operators[key];
        this.props.onChange(newFilter);
    }

    changeValue = (val) => {
        let newFilter = {...this.props.filter};
        newFilter.value = val;
        this.props.onChange(newFilter);
    }

    itemSelected = (item) => {
        let f = this.props.filter;
        let col = f.col;
        let vals = f.value.split(",");
        if (!vals.includes(item[col.valueKey])) {
            vals.push(item[col.valueKey]);
            this.changeValue(vals.join(","));
        }
    }

    itemDeselected = (item) => {
        let f = this.props.filter;
        let col = f.col;
        let vals = f.value.split(",");
        let deleteVal = item[col.valueKey];
        if (vals.includes(deleteVal)) {
            vals.splice(vals.indexOf(deleteVal), 1);
            this.changeValue(vals.join(","));
        }
    }

    getSelectedItems = () => {
        if (this.props.filter) {
            let val = this.props.filter.value;
            let items = this.state.lookupValues;
            let vk = this.props.filter.col.valueKey;

            if (items && val) {
                let selectedVals = val.split(",");
                return items.filter(i => selectedVals.includes(i[vk]));
            }
        }
        return [];
    }

    render() {
        if (!this.props.filter) return <Row></Row>

        let colArray = this.props.cols;
        let f = this.props.filter;
        let i = this.props.index;
        let op = f.operator;
        let col = f.col;
        let t = col.type;

        let lookupCtrl = <></>;
        let selectedItems = [];
        if (t === types.lookup) {
            if (op === operators.in || op === operators.notIn) {
                lookupCtrl = <CollapsibleMultiSelect items={this.state.lookupValues} selectedItems={this.getSelectedItems()} itemSelected={this.itemSelected} itemDeselected={this.itemDeselected} labelKey={col.labelKey} valueKey={col.valueKey}/>
            } else {
                lookupCtrl = <FormControl inline custom as={"select"} value={f.value} onChange={(e) => this.changeValue(e.target.value)}>
                    {this.state.lookupValues.map(v=> <option key={v[col.valueKey]} value={v[col.valueKey]}>{v[col.labelKey]}</option>)}
                </FormControl>
            }
        }

        return <Row>
            <Col>
                {i+1}.
                <FormControl inline={""} custom as={"select"} value={f.col.key} onChange={(e) => this.changeCol(e.target.value)} className={"d-inline-block w-75 ml-2"}>
                    {colArray.map(c => <option key={c.key} value={c.key}>{c.label}</option>)}
                </FormControl>
            </Col>
            <Col>
                <FormControl inline={""} custom as={"select"} value={op.key} onChange={(e) => this.changeOperator(e.target.value)} className={"d-inline-block w-75 ml-2"}>
                    {t.operators.map(o => <option key={o.key} value={o.key}>{o.label}</option>)}
                </FormControl>
            </Col>
            <Col>
                {t === types.int && <FormControl value={f.value || ""} onChange={(e) => this.changeValue(e.target.value)}/>}
                {t === types.string && <FormControl value={f.value || ""} onChange={(e) => this.changeValue(e.target.value)}/>}
                {t === types.date && <FormControl placeholder={"M/D/YYYY"} value={f.value || ""} onChange={(e) => this.changeValue(e.target.value)}/>}
                {t === types.datetime && <FormControl placeholder={"M/D/YYYY H:MM AM"} value={f.value || ""} onChange={(e) => this.changeValue(e.target.value)}/>}
                {t === types.enum && <FormControl inline={""} custom as={"select"} value={f.value} onChange={(e) => this.changeValue(e.target.value)}>
                    {f.col.values.map(v => <option key={v} value={v}>{v}</option>)}
                </FormControl>}
                {t === types.lookup && lookupCtrl}
            </Col>
            <Col md={"auto"}>
                <Glyph name={"x-lg"} className={"clickable text-right"} label={"Remove"} onClick={this.props.onRemove}/>
            </Col>
        </Row>
    }
}